<template>
	<div class="leftres">
		<div class="homePage-top">
			<ReportGuide />
			<CommonQuestions />
		</div>
	</div>
</template>

<script>
	import ReportGuide from './components/ReportGuide.vue';
	import CommonQuestions from './components/CommonQuestions.vue';

	export default {
		components: {
			ReportGuide,
			CommonQuestions
		},
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	.leftres {
		position: relative;
	}

	.homePage-top {
		margin: 20px auto;
		width: 1600px;
		// height: 772px;
		background: #ffffff;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		display: flex;
		justify-content: space-evenly;
		padding-top: 25px;
		user-select: none;
		border-radius: 4px;
	}
</style>